import {
    CONFIG_ADD_NO_OF_DAYS,
    CONFIG_EXPIRE,
    FETCH_SCHEDULAR_SUCCESS,
    FETCH_SCHEDULAR_EXPIRE_TIME_SUCCESS,
    GET_SESSIONS_SUCCESS,
    CLEAR_SESSIONS,
  } from "../constants/schedular.constants";
 
  const INIT_STATE = {
   
    schedularData: {
      config_select_type:"",
      config_expire_select_type:""
    },
    consultationData: {
      consultationTime: 10,
      fee: 0,
      specialty: {}
    },
    sessions: []
  };
  
  const schedularInfo = (state = INIT_STATE, action) => {
    switch (action.type) {
      case CONFIG_ADD_NO_OF_DAYS: {
        return {
          ...state,
          schedularData: {
            ...state.schedularData,
            config_select_type: action.config_add_no_of_days, 
          },
        };
      }

      case FETCH_SCHEDULAR_SUCCESS: {
        return {
          ...state,
          schedularData: {
            ...state.schedularData,
            config_select_type: action.schedular_day,
          },
        }; 
      }
      
      case CONFIG_EXPIRE: {
        return {
          ...state,
          schedularData: {
            ...state.schedularData,
            config_expire_select_type: action.config_expire,
          },
        };
      }

      case  FETCH_SCHEDULAR_EXPIRE_TIME_SUCCESS: {
        return {
          ...state,
          schedularData: {
            ...state.schedularData,
            config_expire_select_type: action.schedular_expire_time,
          },
        };
      }

      case GET_SESSIONS_SUCCESS: {
        const { sessions, consultationTime, fee, specialty } = action.payload.data;
        return {
          ...state,
          consultationData: {
            consultationTime,
            fee,
            specialty
          },
          sessions: sessions,
        }
      }

      case CLEAR_SESSIONS: {
        return {
          ...state,
          sessions: [],
        }
      }

      default:
        return state;
    } 
  };
  
  export default schedularInfo;
  
 